module.exports = __webpack_public_path__ + "static/september-2-a7846586b68381a5d8edafcd37779893.png";